interface IProp {
  className?: string
}

const Hooks = (props:IProp) => {
  const { className = 'stroke-none fill-black' } = props
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      className={className}
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.0026 4.0026C12.0018 4.5926 11.8049 5.1656 11.4429 5.63145C11.0808 6.09729 10.5742 6.42955 10.0026 6.57594V11.3359C10.0026 12.22 9.65141 13.0678 9.02629 13.693C8.40117 14.3181 7.55333 14.6693 6.66927 14.6693C5.78522 14.6693 4.93737 14.3181 4.31225 13.693C3.68713 13.0678 3.33594 12.22 3.33594 11.3359V8.0026L6.66927 11.3359H4.66927C4.66927 11.8664 4.87998 12.3751 5.25506 12.7502C5.63013 13.1252 6.13884 13.3359 6.66927 13.3359C7.1997 13.3359 7.70841 13.1252 8.08348 12.7502C8.45856 12.3751 8.66927 11.8664 8.66927 11.3359V6.57594C7.48927 6.26927 6.66927 5.2026 6.66927 3.9826C6.66927 2.50927 7.86927 1.33594 9.33594 1.33594C10.8159 1.33594 12.0026 2.52927 12.0026 4.0026ZM9.33594 5.33594C9.68956 5.33594 10.0287 5.19546 10.2787 4.94541C10.5288 4.69536 10.6693 4.35623 10.6693 4.0026C10.6693 3.64898 10.5288 3.30984 10.2787 3.0598C10.0287 2.80975 9.68956 2.66927 9.33594 2.66927C8.98232 2.66927 8.64318 2.80975 8.39313 3.0598C8.14308 3.30984 8.0026 3.64898 8.0026 4.0026C8.0026 4.35623 8.14308 4.69536 8.39313 4.94541C8.64318 5.19546 8.98232 5.33594 9.33594 5.33594Z"
        className={className}
      />
    </svg>
  )
}

export default Hooks
